import {Button as TempoButton} from '@tempo/core';
import type {FC, PropsWithChildren, ReactNode} from 'react';
import type {ButtonProps} from '@tempo/core';

export const Button: FC<PropsWithChildren<ButtonProps & {href?: string}>> = ({
	children,
	href,
	...props
}) => {
	const content: ReactNode =
		typeof children === 'string' ? <span>{children}</span> : children;

	return (
		<TempoButton {...(href && {href: href})} {...props}>
			{content}
		</TempoButton>
	);
};
